import { SimpleQuestionAnswer } from '~/types/enums';

export const simpleQuestionOptions = [
  { text: 'Yes', value: SimpleQuestionAnswer.Yes },
  { text: 'No', value: SimpleQuestionAnswer.No },
];

export const simpleQuestionOptionsBoolean = [
  { text: 'Yes', value: true },
  { text: 'No', value: false },
];
